import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';

// Actions
import { loginWithPassword, forgotPassword } from '../../store/login';

// View
import StandardLogin from './StandardLogin';

const mapDispatchToProps = {
  loginWithPassword,
  forgotPassword,
};

const mapStateToProps = (state, ownProps) => {
  // retainer
  return {
    email: state.login.email,
    status: state.login.status,
    loginDomains: state.login.loginDomains,
    passwordLoginResponse: state.login.passwordLoginResponse,
    redirectQuery: state.login.query,
    additionalParams: state.app.params,
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(StandardLogin);
